
export default {
    getStatus(resource) {
        return status[resource];
    }
}

const status = {
    envelopes: [
        {
            name: "all",
            field: "status",
            title:"All Status",
            value: ""
        },
        {
            name: "waiting",
            title:"Waiting for Others",
            field: "status",
            value: "sent|delivered|created"
        },
        {
            name: "expiring",
            title:"Expiring Soon",
            field: "status",
            value: "expiring"
        },
        {
            name: "completed",
            title:"Completed",
            field: "status",
            value: "completed"
        }
    ]
}
 
